import EventEmitter from 'helpers/EventEmitter';

export default new EventEmitter();
